import { render, staticRenderFns } from "./TopBalance.vue?vue&type=template&id=629ba47e&"
import script from "./TopBalance.vue?vue&type=script&lang=js&"
export * from "./TopBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports